// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__7nB2y","AuthForm":"Auth_AuthForm__2nkqz"};